import React, { Component } from 'react';
import PropTypes from "prop-types"
import { Link } from 'react-router-dom';
import isExternal from 'is-url-external';

const propTypes = {
  to: PropTypes.string.isRequired,
};

/**
 * Link that also works for external URL's
 */
export default class LinkCms extends Component {
  render() {
    if ( !this.props.to ) {
      return <span {...this.props}/>
    }
    return isExternal( this.props.to ) ?
      <a
        href={this.props.to}
        target={"_blank"}
        {...this.props}
      />
      :
      <Link {...this.props} />;
  }
}

LinkCms.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Link/LinkCms.js